import isUndefined from 'lodash/isUndefined';
import noop from 'lodash/noop';
import isFunction from 'lodash/isFunction';

const NG_ENABLE_DEBUG_LOG = /^NG_ENABLE_DEBUG_LOG!/;
let _debug = true;

function isEnforceLogging() {
  if (window && NG_ENABLE_DEBUG_LOG.test(window.name)) {
    window.name = window.name.replace(NG_ENABLE_DEBUG_LOG, '');
    return true;
  }
  return false;
}

if (__PROD__) {
  debugEnabled(isEnforceLogging());
}

function debugEnabled (flag) {
  if (isUndefined(flag)) {
    return _debug;
  } else {
    _debug = flag;
  }
}

function _executeGetters(args) {
  return args
    .map((arg) => {
      if (isFunction(arg)) {
        return arg();
      } else {
        return arg;
      }
    });
}

function consoleLog (type) {
  const windowConsole = window.console || {};
  const logFn = windowConsole[type] || windowConsole.log || noop;
  const bindedLog = logFn.bind(windowConsole);

  return (...args) => {
    if (args[0] !== 'modal-close') {
      bindedLog(..._executeGetters(args));
    }
  }
}

function consoleLogByFlag (type, ignoreDebug) {
  const log = consoleLog(type);

  return (...args) => {
    if (_debug || ignoreDebug) {
      log(...args);
    }
  }
}

const log = consoleLog('log');

const info = consoleLog('info');

const warn = consoleLogByFlag('warn');

const error = consoleLogByFlag('error', true);

const debug = consoleLogByFlag('debug');

const table = consoleLogByFlag('table');

const requiredImport = (name) => {

  warn(`"${name}" has to be imported as ES6 module`);
};

const reject = (err) => {
  warn('Chained promise rejection - ', err);

  return Promise.reject(err);
};

function logAsync(asyncFn) {
  return function logAsyncWrapper(...args) {
    return asyncFn(...args)
      .catch(reject);
  };
}

const Logger = {
  log,
  info,
  warn,
  error,
  debug,
  table,
  debugEnabled,
  requiredImport,
  reject,
  logAsync,
};

window.Logger = Logger;

export default Logger;
